module.exports = __webpack_public_path__ + "static/media/blog_grid_3.4d0cc392.jpg";